import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { ExportService } from 'pages/utilities/exports/service';

@inject(DialogController, ExportService)
export class RawMaterialExport {
    constructor(controller, exportService) {
        this.controller = controller;
        this.exportService = exportService;
    }

    async export() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        await this.exportService.exportRawMaterials();
        this.isRequesting = false;
        this.controller.ok();
    }
}